module.exports = __webpack_public_path__ + "static/img/icon-checked-grenn.85418341.png";